// extracted by mini-css-extract-plugin
module.exports = {"container":"BattleCreatePage_container__7hpGv","card":"BattleCreatePage_card__xpusz"};